module.exports = __webpack_public_path__ + "static/media/icon3.e788f340.svg";